import { useContext, useEffect } from 'react';
import context, { shouldIgnoreMixpanel } from 'integrations/mixpanel/useMixpanel';
import { useLoggedInUser } from 'utils/hooks/useLoggedInUser';

export const MixpanelIdentify = () => {
  const mixpanel = useContext(context);
  const authUser = useLoggedInUser();
  const userUid = authUser?.uid ?? 'unknown';

  useEffect(() => {
    if (!!userUid && !!mixpanel && 'identify' in mixpanel && !shouldIgnoreMixpanel) {
      mixpanel?.identify?.(userUid);
    }
  }, [userUid, mixpanel]);
  return null;
};
